import React from 'react';
import { Button } from '../components/ui/button';
import { ShoppingCart, ArrowLeft, Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function ComingSoon() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-sand to-white p-4">
      <div className="w-full max-w-md text-center">
        {/* Icon */}
        <div className="mb-6 flex justify-center">
          <div className="rounded-full bg-coral/10 p-6">
            <ShoppingCart className="h-16 w-16 text-coral" />
          </div>
        </div>

        {/* Heading */}
        <h1 className="mb-3 text-3xl font-bold text-dusk">
          Coming Soon!
        </h1>

        <p className="mb-2 text-lg text-dusk">
          Shopping Lists
        </p>

        <p className="mb-8 text-supporting">
          We're working hard to bring you an amazing shopping list experience.
          Generate ingredient lists from your meal plans, organize by store sections,
          and check off items as you shop!
        </p>

        {/* Features Preview */}
        <div className="mb-8 rounded-lg bg-white p-6 text-left shadow-sm">
          <h3 className="mb-4 flex items-center gap-2 font-semibold text-dusk">
            <Sparkles className="h-5 w-5 text-coral" />
            What's Coming
          </h3>
          <ul className="space-y-2 text-sm text-supporting">
            <li className="flex items-start gap-2">
              <span className="text-coral">✓</span>
              <span>Auto-generate lists from meal plans</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-coral">✓</span>
              <span>Organize by store sections</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-coral">✓</span>
              <span>Smart ingredient consolidation</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-coral">✓</span>
              <span>Mobile-friendly shopping mode</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-coral">✓</span>
              <span>Share lists with household members</span>
            </li>
          </ul>
        </div>

        {/* Actions */}
        <div className="flex flex-col gap-3">
          <Button
            size="lg"
            onClick={() => navigate('/')}
            className="w-full gap-2 bg-coral hover:bg-coral/90"
          >
            <ArrowLeft className="h-5 w-5" />
            Back to Dashboard
          </Button>

          <Button
            size="lg"
            variant="outline"
            onClick={() => navigate('/discover')}
            className="w-full"
          >
            Discover Recipes
          </Button>
        </div>

        {/* Footer Note */}
        <p className="mt-6 text-xs text-supporting">
          Want to be notified when this launches?
          <br />
          We'll send you an email as soon as it's ready!
        </p>
      </div>
    </div>
  );
}
